import {
  adSlotSizes,
  midArticleAdSlotSizesInfinteScroll,
  pubPageAdTargeting,
} from "@config/AdsConstants";
import CompanionAdvertisement from "@elements/Advertisement/CompanionAdvertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdPageTargetingType,
  ArticleAdSlotTargetingType,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { twMerge } from "tailwind-merge";

type CompanionAdsImuProps = {
  uniqueSectionName: string;
  rootClassName?: string;
  pageAdTargetType: PageAdTargetValue;
  pageNumber: number;
  articlePageTarget?: ArticleAdPageTargetingType[];
  articleSlotTarget?: ArticleAdSlotTargetingType[];
  gsChannels?: string[];
  overrideImu2AdSlots?: googletag.GeneralSize;
  subRootClassName?: string;
};

/**
 * Tabla Companion Imu1, Imu2 & midadrticle Ad
 * Description: The Imu1,Imu2 & midadrticle component for rendering ads.
 * @name - name of section or page
 */

export function CompanionAdsImu1({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  pageNumber,
  articlePageTarget,
  articleSlotTarget,
  gsChannels,
}: CompanionAdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.IMU1,
        slot: GoogleAdsSlotFactory(
          AdvertisementTypeEnum.IMU1,
          uniqueSectionName,
        ),
        id: `dfp-ad-imu1-${pageNumber}`,
        adSlotSize: adSlotSizes["imu1"],
        pageNumber: pageNumber.toString(),
        pubAdTargeting: [PubPageAdTarget],
        articlePageTarget,
        articleSlotTarget,
        gsChannels,
      }}
    />
  );
}
export function CompanionAdsImu2({
  uniqueSectionName,
  pageAdTargetType,
  pageNumber,
  articlePageTarget,
  articleSlotTarget,
  rootClassName,
  gsChannels,
  overrideImu2AdSlots,
  subRootClassName,
}: CompanionAdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  const imu2adSlots = overrideImu2AdSlots ?? adSlotSizes["imu2"];

  return (
    <div className={twMerge("mb-5 xmd:my-5 w-full", rootClassName)}>
      <CompanionAdvertisement
        rootClassName={twMerge(
          "lg:sticky lg:top-20 xmd:p-x1s justify-items-center w-full",
          subRootClassName,
        )}
        companionAdUnitProps={{
          type: AdvertisementTypeEnum.IMU2,
          slot: GoogleAdsSlotFactory(
            AdvertisementTypeEnum.IMU2,
            uniqueSectionName,
          ),
          id: `dfp-ad-imu2-${pageNumber}`,
          adSlotSize: imu2adSlots,
          pageNumber: pageNumber.toString(),
          pubAdTargeting: [PubPageAdTarget],
          articlePageTarget,
          articleSlotTarget,
          gsChannels,
        }}
      />
    </div>
  );
}

export function CompanionAdsMidArticle({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  pageNumber,
  articlePageTarget,
  articleSlotTarget,
  gsChannels,
}: CompanionAdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("block", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.MIDARTICLESPECIAL,
        slot: GoogleAdsSlotFactory(
          AdvertisementTypeEnum.MIDARTICLESPECIAL,
          uniqueSectionName,
        ),
        id: `dfp-ad-midarticlespecial-${pageNumber}`,
        adSlotSize: midArticleAdSlotSizesInfinteScroll["midArticle"],
        pageNumber: pageNumber.toString(),
        pubAdTargeting: [PubPageAdTarget],
        articlePageTarget,
        articleSlotTarget,
        gsChannels,
      }}
    />
  );
}
